<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>What's on</h1>
        </div>
    </section>
  </div>

  <section class="section">
    <WhatsonRows :items="playsCurrent" />
  </section>

  <section class="section grey-block">
    <div class="container content whatsonrows-title">
      <h3 class="title block-title">
        Coming soon
      </h3>
    </div>

    <WhatsonRows :items="playsUpcoming" />
  </section>

</div>
</template>

<script>
import WhatsonRows from './cards/WhatsonRows';
import Api from '@/config/Api'

export default {
    components: {
        WhatsonRows
    },
    data() {
        return {
            playsCurrent: [],
            playsUpcoming: []
        }
    },
    /* computed: {
        country() {
            return this.$store.getters.getCountry
        }
    }, */
    created() {
        Api().get(`/api/plays/whatson`).then(response => {
            this.playsCurrent = response.data.currentPlays;
            this.playsUpcoming = response.data.upcomingPlays;
            console.log("whatson created", this.plays);
            this.$store.commit('setContentLoaded', true); // then footer will be displayed
        });
    },
    methods: {
        /*checkPage(url) {
            Api().get(url).then(response => {
                console.log("checkPage url:",url);
                this.products = response.data.products;
                this.currentPage = response.data.currentPage;
                this.pages = response.data.pages;
                this.nextUrl = response.data.nextUrl;
                this.prevUrl = response.data.prevUrl;
            })
        }*/
    },
    metaInfo: {
      title: "What's on",
      // titleTemplate: null // override the parent template and just use the above title only
      
    }
}
</script>

<style scoped>
    .whatsonrows-title {
        margin-bottom: 3em;
    }
</style>



// WEBPACK FOOTER //
// src/components/Whatson.vue